/**
 * AI.GEN lines=1-35
 * 国家代码配置
 */
import { timezonesEnum, type ICountryCode } from '@/common/enum';

export type { ICountryCode };

const getCountryCode = (): ICountryCode => {
  const countryList: ICountryCode[] = [
    'NZ',
    'EUR',
    'US',
    'AU',
    'CA',
    'JP',
    'SG',
    'KR',
    'GB',
  ];

  // 从环境变量获取国家代码（生产环境）
  const envCountry = process.env.country?.toUpperCase();

  // 从 URL 参数获取国家代码（开发/测试环境）
  const urlParams = new URLSearchParams(window.location.search);
  const urlCountry = urlParams.get('countryCode')?.toUpperCase();

  // 优先使用环境变量，其次使用 URL 参数，最后默认 'CA'
  const code = (envCountry || urlCountry || 'CA') as ICountryCode;

  return countryList.includes(code) ? code : 'CA';
};

export const countryCode = getCountryCode();

/**
 * 默认时区（根据当前国家代码获取）
 */
export const defaultTimezone = timezonesEnum[countryCode] || timezonesEnum.CA;
